import { cypherUrl } from 'endpoints';
import fetch from '../utils/fetch';

export const apiGetStacks = async ( ) => {
    try {
        const res = await fetch( `${ cypherUrl }/stacks`, {
            method: 'GET',
            headers: { 'content-type': 'application/json' },
        } );
    
        const data = await res.json();
    
        return data;
    } catch ( error ) {
        throw new Error( error );
    }
};

export const apiGetStack = async ( stackId ) => {
    try {
        const res = await fetch( `${ cypherUrl }/stacks/${ stackId }`, {
            method: 'GET',
            headers: { 'content-type': 'application/json' },
        } );
    
        const data = await res.json();
    
        return data;
    } catch ( error ) {
        throw new Error( error );
    }
};


export const apiGetKeyStringsByName = async ( keyName, stackId, companyId ) => {
    try {
        const res = await fetch( `${ cypherUrl }/strings/stack/${ stackId }/key/${ keyName }`, {
            method: 'GET',
            headers: { 'content-type': 'application/json', 'x-company-id': companyId }
        } );

        const data = await res.json();

        return data;
    } catch ( error ) {
        throw new Error( error );
    }
};

export const apiCreateString = async ( body, companyId ) => {
    try {
        const res = await fetch( `${ cypherUrl }/strings/`, {
            method: 'POST',
            headers: { 'content-type': 'application/json', 'x-company-id': companyId },
            body: JSON.stringify( body )
        } );

        const data = await res.json();

        return data;
    } catch ( error ) {
        throw new Error( error );
    }
};

export const apiUpdateString = async(  string, companyId ) => {
    try {
        const res = await fetch( `${ cypherUrl }/strings/${ string.id }`, {
            method: 'PUT',
            headers: { 'content-type': 'application/json', 'x-company-id': companyId },
            body: JSON.stringify( string )
        } );

        const data = await res.json();

        return data;
    } catch ( error ) {
        throw new Error( error );
    }
};
export const apiGetBlockString = async( companyId, stackCode, targetType, targetId, localeCode ) => {
    try {
        const query = new URLSearchParams( { localeCode, useCache: false } ).toString();
        const res = await fetch( `${ cypherUrl }/blocks/strings/${ stackCode }/${ targetType }/${ targetId }?${ query }`, {
            method: 'GET',
            headers: { 'content-type': 'application/json', 'x-company-id': companyId }
        } );

        const data = await res.json();

        return data;
    } catch ( error ) {
        throw new Error( error );
    }
};